import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AboutComponent implements AfterViewInit {
  version = '';
  author = '';
  license = '';

  @ViewChild('changelogOutput', { read: ElementRef }) private changelogOutput: ElementRef;

  constructor(
    private http: HttpClient,
    private modalController: ModalController,
    private renderer: Renderer2,
  ) { }

  ngAfterViewInit(): void {
    const parser = new DOMParser();

    this.http.get('assets/changelog.html', {
      responseType: 'text'
    }).subscribe(response => {
      const changelogDoc = parser.parseFromString(response, 'text/html');
      const changelogContent = changelogDoc.querySelector('.markdown-style');

      // Remove empty changelog categories.
      changelogContent.querySelectorAll('h3').forEach(h3Heading => {
        if (h3Heading.nextElementSibling?.nodeName.toUpperCase() !== 'UL') {
          changelogContent.removeChild(h3Heading);
        }
      });

      this.renderer.appendChild(this.changelogOutput.nativeElement, changelogContent);
    });

    this.http.get('assets/about.json').subscribe((aboutData: any) => {
      this.author = aboutData.author;
      this.version = aboutData.version;
      this.license = aboutData.license;
    });
  }

  close() {
    this.modalController.dismiss();
  }
}
